/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9999 5.0863L18.9999 9.0863M21.1739 6.89832C21.7026 6.36974 21.9997 5.65279 21.9998 4.90517C21.9999 4.15756 21.703 3.44053 21.1744 2.91182C20.6459 2.38311 19.9289 2.08603 19.1813 2.08594C18.4337 2.08584 17.7166 2.38274 17.1879 2.91132L3.84193 16.2603C3.60975 16.4918 3.43805 16.7769 3.34193 17.0903L2.02093 21.4423C1.99509 21.5288 1.99314 21.6207 2.01529 21.7082C2.03743 21.7957 2.08285 21.8755 2.14673 21.9393C2.21061 22.0031 2.29055 22.0484 2.37809 22.0704C2.46563 22.0924 2.55749 22.0903 2.64393 22.0643L6.99693 20.7443C7.3101 20.6491 7.59511 20.4784 7.82693 20.2473L21.1739 6.89832Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
